import SolicitacaoReembolsoAtividade from './componentes/SolicitacaoReembolsoAtividade.vue';
import SolicitacaoReembolsoAtividadeLista from './componentes/SolicitacaoReembolsoAtividadeLista.vue';
import SolicitacaoReembolsoAtividadeForm from './componentes/SolicitacaoReembolsoAtividadeForm.vue';

export default {
  path: '/solicitacao-reembolso-pf-atividade',
  component: SolicitacaoReembolsoAtividade,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoReembolsoAtividadeLista,
      name: 'solicitacao-reembolso-pf-atividade',
    },
    {
      path: ':idCript/atividade',
      component: SolicitacaoReembolsoAtividadeForm,
      name: 'solicitacao-reembolso-pf-atividade.registrar',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso-atividade/rotas.js